import { render } from "./Order.vue?vue&type=template&id=cbcda928"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\flaggerforce\\flagger-force-orders-module\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__